import React from 'react';
import { Route } from 'react-router-dom';

import LoginPageRoute from './LoginPageRoute';

export const routes = [
  <Route exact path={'*'} key={'loginPage'} component={LoginPageRoute} />
];
